import React from 'react'
import cx from 'classnames'

import Image from '@/image.js'

class MemebershipHero extends React.Component {
  constructor() {
    super()
    this.state = {
      visible: false
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        visible: true
      })
    }, 1000)
  }
  render() {
    const {
      headerImages,
      description,
      descriptionTwo,
      titleOne,
      titleTwo
    } = this.props
    return (
      <div className={cx('membership__hero', {
        'is-animated': this.state.visible
      })}>
        <div className='container--xl rel mxa p15'>
          <div className='membership__block mb15 f jcs'>
            <div className='container--h animate a-t a-o a-d-2'>
              <h1 className='p0 m0'>{titleOne}</h1>
              <p>{description}</p>
            </div>
          </div>
          <div className='membership__images f fw jcc'>
            {headerImages.map(image => (
              <Image key={image.imageId} className='py1 animate a-o a-t x' imageId={image.imageId} />
            ))}
          </div>
          <div className='membership__block mt15 f jce'>
            <div className='container--h animate a-t a-o a-d-6'>
              <h1 className='p0 m0'>{titleTwo}</h1>
              <p>{descriptionTwo}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MemebershipHero